import React from 'react';

const valueOrEmpty = value => ((!value || value === '') ? <i>Empty</i> : value);

export default valueOrEmpty;
